"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthoringAppProtectedRoute = void 0;
exports.AuthoringAppProtectedRoute = {
    // TODO: authoring prefix where missing
    SubmitAutomationProjectMutation: '/authoring/mutate',
    ResolveDataRefs: '/authoring/resolve_data_refs',
    // todo: move/update:
    JoinWsDataSync: '/authoring/realtime/data_sync',
    FetchInitialWsState: '/authoring/realtime/initial_state/:wsAuthToken',
    // tbd: LeaveWsTopic: '/realtime/leave_topic/:wsTopic',
};
//# sourceMappingURL=routes-authoring-app-protected-api.js.map